import React from "react";
import Hero from "./hero";

export default function Header({ content }) {
  return <div id="header">{content ? <Hero content={content} /> : null}</div>;
}
